<div class="card mb-5 mb-xl-8">
  <div class="card-body py-3">
    <div class="container">
      <form data-kt-search-element="form" class="w-50 position-relative mb-3" autocomplete="off">
        <span [inlineSVG]="'./assets/media/icons/duotune/general/gen021.svg'"
          class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-3"></span>
        <input type="text" class="form-control form-control-flush ps-10 border ps-13" name="search"
          [value]="searchService.searchKeyworld.value" [placeholder]="'MenuDashboard.searchHolder' | translate"
          data-kt-search-element="input" (keyup)="search($event)" />
        <!-- [(ngModel)]="searchQ" -->
        <!-- (input)="search($event.target.value)" -->
      </form>
      <div *ngIf="resultsCategories" class="w-100 d-flex justify-content-start align-items-start mt-8">
        <h2>{{resultsCategories[0].nbr}} {{'search.results_found' | translate}} </h2>
        <div class="ms-16 d-flex gap-8 justify-content-start align-items-end">
          <a role="button" class="search-category-menu-item fw-bolder " *ngFor="let item of resultsCategories"
            [class.active]="item.key===searchService.getCheckedCategory()" (click)="handleActive(item)">
            {{'search.'+item.title | translate}} ({{item.nbr}})</a>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="isLoading | async">
  <div class="progress-bar" [class.invisible]="!isLoading">
    <div class="progress-bar-value"></div>
  </div>
</ng-container>
<!-- results part -->
<ng-container *ngIf="results$ |async as results">
  <ng-container *ngFor="let key of getKeys(results)">

    <ng-container *ngIf="['',key].includes(searchService.getCheckedCategory()) && results[key].length>0"
      lcmsDynamicSearchComponent [cmpName]="key" [cmpData]="results[key]"
      [showDetails]="searchService.getCheckedCategory()===key">

    </ng-container>
  </ng-container>
</ng-container>